import type { Permission } from '@teachino/shared-util';
import { useGlobalDependencyProvider } from '@teachino/shared-util';
import { computed } from 'vue';
import { canUseProFeature } from './soft-paywall';
import { useLicense } from './useLicense';

/** Whether the user can use a Pro feature (grace, trial, and license rules applied). */
export function useCanUseProFeature(feature: Permission) {
  const user = useGlobalDependencyProvider().inject('user');
  const { paywallLicenses } = useLicense();

  return computed(() =>
    canUseProFeature(
      feature,
      user.hasPermission(feature).value,
      paywallLicenses.value,
      user.accountCreatedAt.value,
    ),
  );
}
